import { GenericReportDownload } from '@/types/downloadReports';

import { createAction, createAsyncAction } from 'typesafe-actions';

export type BulkDealNameUpdateRow = {
  transaction_id: number;
  deal_name?: string;
  sub_deal_name?: string;
  classification_tag?: string;
};

export type BulkDealNameUpdateRequestPayload = {
  rows: BulkDealNameUpdateRow[];
};

export type BulkDealNameUpdateRowError = {
  row: number;
  transaction_id?: string;
  error: string;
};

export type BulkDealNameUpdateResultData = {
  success: boolean;
  total_rows: number;
  trade_request_deal_name_rows_updated: number;
  transaction_summary_comments_rows_updated: number;
  trade_request_sub_deal_name_rows_updated: number;
  transaction_summary_sub_deal_name_rows_updated: number;
  trade_request_classification_tag_rows_updated: number;
  classification_relationship_rows_updated: number;
  skipped: number;
  errors: BulkDealNameUpdateRowError[];
  error?: string;
};

export type BulkDealNameUpdateSuccessPayload = {
  result: BulkDealNameUpdateResultData;
};

export const getDownloadBulkDealNameUpdateTemplate = createAsyncAction(
  'bulkDealNameUpdate/downloadTemplate/request',
  'bulkDealNameUpdate/downloadTemplate/success',
  'bulkDealNameUpdate/downloadTemplate/failure',
)<undefined, { data: GenericReportDownload }, undefined>();

export const submitBulkDealNameUpdate = createAsyncAction(
  'bulkDealNameUpdate/submit/request',
  'bulkDealNameUpdate/submit/success',
  'bulkDealNameUpdate/submit/failure',
)<
  BulkDealNameUpdateRequestPayload,
  BulkDealNameUpdateSuccessPayload,
  undefined
>();

export const clearBulkDealNameUpdateResult = createAction(
  'bulkDealNameUpdate/clearResult',
)();
